import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Empty_LetterRequestCustomer_Order_Interface, LetterRequestCustomer_Order_Interface } from 'src/app/Interface/LetterRequestCustomer_Order_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerPreOrder',
  templateUrl: './LetterRequestCustomerPreOrder.component.html',
  styleUrls: ['./LetterRequestCustomerPreOrder.component.scss']
})
export class LetterRequestCustomerPreOrderComponent implements OnInit {
  Dsc: String = ""
  Delivery: String = ""
  Letter_Form_Id: any
  InProccessing: boolean = false
  has_calibration_customer_order: boolean = false
  parentRefer: number = 0
  BaseUrl = environment.BaseUrl + "Fish/LetterPreOrder?id="
  BaseURlFile = environment.BaseUrl

  canEditMainForm: boolean
  canDownloadPDF: boolean
  canReviewDetail: boolean
  canShowSendSMS: boolean

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private router: Router,
    private Device_Service: DeviceService,
    private route: ActivatedRoute,
    private MailMessage_Service: MailMessageService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Letter_Form_Id = this.route.snapshot.paramMap.get('id')

    this.BaseUrl=environment.BaseUrl + "Fish/LetterPreOrder?id="

    this.DeviceForm = new FormGroup({
      id: new FormControl(),
      device_id: new FormControl("0", Validators.required),
      tedad: new FormControl(null, Validators.required),
      dsc: new FormControl(null),
    })

    this.MailMessageForm = new FormGroup({
      mailmessage_id: new FormControl("0", Validators.required),
    })

    if (this.Letter_Form_Id && this.Letter_Form_Id != '0') {
      this.OnInitail_Form();
    }

    else {
      this.Letter_Form_Id = "0"
      this.Read_Order_Operation()
    }


  }

  OnInitail_Form() {
    this.LetterRequestCustomer_Service.GetSingle(this.Letter_Form_Id).subscribe(
      data => {
        this.Read_Order_Operation()
        this.DeviceFormList = data['device']
        this.FormAdded_MailMessage = data['mail']
        this.Data_Seleted_Customer = data['cusomter']
        this.Letter_Form_Code = data['lettercode']
        this.has_calibration_customer_order = data['has_calibration_customer_order']

        this.Dsc = data['main'].dsc
        this.Delivery = data['main'].delivery
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#region  مشتری
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  modalRef_CustomerAdress: any;
  page: number = 0

  Edit_Customer_Record: Customer_Interface = Empty_Customer_Interface()

  Search_CodeName_Customer_Table: string = ''
  Search_Type_Customer_Table: string = '2'

  DataList_Customer: Array<Customer_List_Interface> = []
  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()


  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {

      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }

  openModal_CustomerAddress(template: TemplateRef<any>) {
    this.modalRef_CustomerAdress = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item) {
    this.Data_Seleted_Customer = item
    this.modalRef_Customer.hide()
  }



  //#endregion

  //#region Device
  DeviceFormList: Array<LetterRequestCustomer_Device_Interface> = []
  DeviceForm: FormGroup;
  DeviceFormListPriceTotal: number = 0
  DeviceFormListTakhfifTotal: number = 0
  DeviceFormListarsh_afzoodehTotal: number = 0

  get_DeviceForm_id() {
    return this.DeviceForm.get('id') as FormControl;
  }

  get_DeviceForm_device_id() {
    return this.DeviceForm.get('device_id') as FormControl;
  }

  get_DeviceForm_tedad() {
    return this.DeviceForm.get('tedad') as FormControl;
  }

  get_DeviceForm_dsc() {
    return this.DeviceForm.get('dsc') as FormControl;
  }


  DeviceForm_Submit() {

    if (this.Data_Seleted_Device_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("تجهیز را انتخاب کنید")
    }
    else {
      var temp: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface()
      temp.device_id = this.Data_Seleted_Device_Record.id
      temp.device_name = this.Data_Seleted_Device_Record.title

      temp.tedad = Number(this.get_DeviceForm_tedad().value)
      temp.dsc = this.get_DeviceForm_dsc().value
      this.DeviceFormList.push(temp)
      this.get_DeviceForm_dsc().setValue("")
    }

  }


  DeleteDeviceFormList_Index: number = -1;
  DeleteDeviceFormList_Record: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface();

  modalRef_DeleteDeviceFormList:any
  DeleteDeviceFormList_Modal(template: TemplateRef<any>,id:number) {
    this.DeleteDeviceFormList_Index = id
    this.DeleteDeviceFormList_Record = this.DeviceFormList[this.DeleteDeviceFormList_Index]
    this.modalRef_DeleteDeviceFormList = this.modalService.show(template);
  }

  DeleteDeviceFormList() {

    if (this.DeleteDeviceFormList_Record.id == 0)
    {
      this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
      this.Alertify_Service.SuccessMessage(" حذف شد")
      this.modalRef_DeleteDeviceFormList.hide()
    }
    else {
      this.InProccessing=true
      this.LetterRequestCustomer_Service.DeleteDevice(this.DeleteDeviceFormList_Record.id).subscribe(
        data => {
          this.InProccessing = false
          this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
          this.Alertify_Service.SuccessMessage(" حذف شد")
          this.modalRef_DeleteDeviceFormList.hide()
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }


  //#endregion

  //#region  دستگاه

  modalRef_Device: any;

  ProcssingDevice: boolean = false

  Search_Name_Device_Table: string = ''
  Search_Code_Device_Table: string = ''

  openModal_Device(template: TemplateRef<any>) {
    this.modalRef_Device = this.modalService.show(template);
  }

  DataList_Device: Array<Device_Interface> = []
  Data_Seleted_Device_Record: Device_Interface = Empty_Device_Interface()

  ReadData_Device_KeySearch_Timer: any
  ReadData_Device_KeySearch() {

    if (this.ReadData_Device_KeySearch_Timer) {
      clearTimeout(this.ReadData_Device_KeySearch_Timer);
      this.ReadData_Device_KeySearch_Timer = null;
    }

    this.ReadData_Device_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Device()
    }.bind(this), 1000);

  }

  ReadData_Device() {


    if (!this.Search_Name_Device_Table) {
      this.DataList_Device = []
    }
    else {
      this.ProcssingDevice = true
      this.Device_Service.GetSearchCalibration(this.Search_Name_Device_Table, this.Search_Code_Device_Table).subscribe(
        data => {
          this.DataList_Device = data
          this.ProcssingDevice = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  Set_Selected_Device_Record(item) {
    this.Data_Seleted_Device_Record = item
    this.modalRef_Device.hide()

  }

  //#endregion


  //#region History

  Show_History_View: number = 0
  DataList_History: Array<LetterRequestCustomer_History_Interface> = []
  ReadHistory_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetHistory(Number(this.Letter_Form_Id)).subscribe(
      data => {
        this.InProccessing = false
        this.Show_History_View = 1
        this.DataList_History = data
        this.ReadPeyvast_Letter()

      }
    )
  }

  DataList_Peyvast: Array<LetterRequestCustomer_List_Interface> = []
  canOpenPeyvast: boolean=false
  ReadPeyvast_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetPeyvast1(Number(this.Letter_Form_Id)).subscribe(
      data => {
        this.InProccessing = false
        this.DataList_Peyvast = data['result']
        this.canOpenPeyvast = data['canOpen']
      }
    )
  }

  Close_Show_History() {
    this.Show_History_View = 0
  }

  //#endregion


  //#region Note Letter

  modalRef_Note: any;
  Note_Dsc: string = ''
  OpenNoteDialog(template: TemplateRef<any>) {
    this.modalRef_Note = this.modalService.show(template);
    this.Note_Dsc = ''
  }

  SubmitNote() {
    if (!this.Note_Dsc) {
      this.Alertify_Service.ErrorMessage("شرح را وارد نمائید")
    }
    else {
      this.InProccessing = true

      this.Customer_Service.AddComment(this.Note_Dsc,this.Data_Seleted_Customer.id).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("نظر ثبت شد")
          this.InProccessing = false
          this.Note_Dsc = ''
          this.modalRef_Note.hide()
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

  //#endregion

  //#region Letter Order

  Data_List_Order: Array<LetterRequestCustomer_Order_Interface>
  Read_Order_Operation() {
    this.Data_List_Order = []
    this.LetterRequestCustomer_Service.GetOperation(Number(this.Letter_Form_Id), 0, false, true, false).subscribe(
      data => {
        this.ReadData_MailMessage()
        this.Data_List_Order = data['result']
        this.canEditMainForm = data['canEditMainForm']
        this.canDownloadPDF = data['canDownloadPDF']
        this.canReviewDetail = data['canReviewDetail']
        this.parentRefer = data['parentRefer']
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  Selected_Order_Operation: LetterRequestCustomer_Order_Interface = Empty_LetterRequestCustomer_Order_Interface()
  SelectedLetterRole: string = '0'
  LetterHistoryDsc: string = ''
  modalRef_Order: any;
  Data_list_LetterRole: Array<General_Interface> = []

  OpenOrderDialog(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {
    this.Data_list_LetterRole = []
    this.SelectedLetterRole = '0'
    this.LetterHistoryDsc = ''
    this.Selected_Order_Operation = item
    this.InProccessing=true
    this.LetterRequestCustomer_Service.GetUserrole(item.id,item.role_id).subscribe(
      data => {
        this.Data_list_LetterRole = data
        this.InProccessing=false
        this.modalRef_Order = this.modalService.show(template);
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion


  //#region MailMessage
  MailMessageForm: FormGroup
  DataList_MailMessage: Array<MailMessage_Interface> = []
  FormAdded_MailMessage: Array<General_Interface> = []

  ReadData_MailMessage() {
    this.MailMessage_Service.GetRecord(2).subscribe(
      data => {
        this.DataList_MailMessage = data
      }
    )
  }

  get_MailMessageForm_mailmessage_id() {
    return this.MailMessageForm.get('mailmessage_id') as FormControl;
  }

  MailMessageForm_Delete(id) {
    this.FormAdded_MailMessage.splice(id, 1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  MailMessageForm_Submit() {
    if (this.get_MailMessageForm_mailmessage_id().value == "0") {
      this.Alertify_Service.ErrorMessage("پیام نامه انتخاب نمائید")
    }
    else {
      var Chekcer: boolean = false
      for (let detail of this.FormAdded_MailMessage) {
        if (detail.id == Number(this.get_MailMessageForm_mailmessage_id().value)) {
          Chekcer = true
          break
        }
      }

      if (Chekcer) {
        this.Alertify_Service.ErrorMessage("پیام نامه مورد نظر در لیست ثبت شده است")
      }
      else {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = Number(this.get_MailMessageForm_mailmessage_id().value)
        temp.title = this.Find_MailMessage(temp.id)
        this.FormAdded_MailMessage.push(temp)
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
      }
    }

  }

  Find_MailMessage(id: number) {
    for (let item of this.DataList_MailMessage) {
      if (id == item.id) {
        return item.title
      }
    }
  }

  //#endregion

  //#region Image

    modalRef_ImageForm: any;
    seleted_LetterRequestCustomer_Device:LetterRequestCustomer_Device_Interface=Empty_LetterRequestCustomer_Device_Interface()
    OpenImageDialog(template: TemplateRef<any>,item:LetterRequestCustomer_Device_Interface) {
      this.modalRef_ImageForm = this.modalService.show(template);
      this.seleted_LetterRequestCustomer_Device=item
    }


    UploadImageSrc: string = ''
    InProccessing_Image1: boolean = false
    uploadImage1(files) {
      if (files.length === 0)
        return;

      const formData = new FormData();

      for (const file of files) {
        formData.append(file.name, file);
      }

      this.InProccessing_Image1 = true

      this.LetterRequestCustomer_Service.uploadFile(formData).subscribe(
        data => {
          this.InProccessing_Image1 = false
          if (data['id'] == 0) {
            this.Alertify_Service.ErrorMessage(data['filename'])
          }
          else {
            this.Alertify_Service.SuccessMessage("فایل آپلود شد")
            this.UploadImageSrc = data['filename']
          }
        }
      )

    }

    Remove_uploadImage1() {
      this.UploadImageSrc = ''
    }

    Add_uploadImage1() {
      this.seleted_LetterRequestCustomer_Device.file.push(this.UploadImageSrc)
      this.UploadImageSrc = ''
      this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
    }

    UploadImageSrc_List_Delete(id: number,item:LetterRequestCustomer_Device_Interface) {
      item.file.splice(id, 1)
      this.Alertify_Service.SuccessMessage("حذف شد")
    }


    modalRef_Image: any;
    ModalimageUrl: string = ''
    openModal(template: TemplateRef<any>, imageUrl: string) {
      this.ModalimageUrl = imageUrl
      this.modalRef_Image = this.modalService.show(template);
    }

    //#endregion


  Letter_Form_Code: String = ''
  modalRef_Code: any;

  NewForm(){
    this.router.navigateByUrl('LetterRequestCustomerPreOrder');
    this.Letter_Form_Id=0

    this.Read_Order_Operation()
    this.DeviceFormList = []
    this.FormAdded_MailMessage = []
    this.Data_Seleted_Customer = Empty_Customer_List_Interface()

    this.Dsc = ''
    this.Delivery = ''
  }


  SubmitAddNewLetter(template: TemplateRef<any>, GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {

    if (this.DeviceFormList.length == 0 && Order.id!=22) {
      this.Alertify_Service.ErrorMessage("حداقل یک مورد تجهیز وارد نمائید")
    }
    else {
      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = Number(this.Letter_Form_Id)
      temp.dsc = this.Dsc
      temp.delivery = this.Delivery

      var tempAddress: Address_Interface = Empty_Address_Interface()


      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditLetterRequestCustomer(
        temp,
        "",
        this.Data_Seleted_Customer,
        tempAddress,
        this.DeviceFormList,
        [],
        this.FormAdded_MailMessage,
        [],
        [],
        [],
        false,
        true,
        false,
        0,
        false,
        GiverUser,
        Order.goSection,
        Order.id,
        this.LetterHistoryDsc,
        this.parentRefer,
        1).subscribe(
          data => {
            this.Letter_Form_Code = data['giver_name']
            this.Letter_Form_Id = data['id']

            if (Order.id!=22 ) {
              this.canShowSendSMS = true
              this.Read_Customer_Karshnash(template)
              this.SendSMS_Order=Order.id
            }
            else {
              this.canShowSendSMS = false
              this.modalRef_Code = this.modalService.show(template);
            }

            this.OnInitail_Form()
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.InProccessing = false
            this.canEditMainForm = false
          }
        )
    }
  }

  SubmitActionLetter(template: TemplateRef<any>,GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {

    if(!this.LetterHistoryDsc.trim() && Order.id!=22)
    {
      this.Alertify_Service.ErrorMessage("توضیحات را وارد نمائید")
    }
    else{
    this.InProccessing = true
    this.LetterRequestCustomer_Service.SubmitActionLetter(
      this.Letter_Form_Id,
      GiverUser,
      Order.goSection,
      Order.id,
      this.LetterHistoryDsc,
      this.parentRefer).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")



          if(Order.id!=22)
          {
            this.SendSMS_Order=17
            this.canShowSendSMS = true
            this.Read_Customer_Karshnash(template)
          }
          else {
            this.canEditMainForm = false
            this.InProccessing = false
            this.modalRef_Code = this.modalService.show(template);
          }
          this.Read_Order_Operation()
        }
      )
    }
  }


  SubmitAddNewLetter_Co(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {

    if (item.submit) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("گیرنده را انتخاب کنید")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitAddNewLetter(template, Number(this.SelectedLetterRole), item)
      }
    }
    else if (item.hasRefer) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("گیرنده را انتخاب کنید")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitActionLetter(template,Number(this.SelectedLetterRole), item)
      }
    }
    else {
      this.modalRef_Order.hide()
      this.SubmitActionLetter(template,0, item)
    }
  }

  //#region SMS

  DataList_Karshnash:Array<KarshnasMasol_Interface>=[]
  SendSMS_Order:number=0
  SendSMS() {

    var Karshnash_Id:string='-1'
    for(let item of this.DataList_Karshnash)
    {
      if(item.del)
      {
        Karshnash_Id=Karshnash_Id+","+item.id
      }
    }


    this.modalRef_Code.hide()
    this.LetterRequestCustomer_Service.SendSmsLetter(Number(this.Letter_Form_Id),this.SendSMS_Order,Karshnash_Id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("پیامک ارسال شد")
      }
    )
  }

  SendSMS_NoMatch() {

    var Karshnash_Id:string='-1'
    for(let item of this.DataList_Karshnash)
    {
      if(item.del)
      {
        Karshnash_Id=Karshnash_Id+","+item.id
      }
    }


    this.modalRef_Code.hide()
    this.LetterRequestCustomer_Service.SendSmsLetter_PreOrder_NoMatch(Number(this.Letter_Form_Id),this.SendSMS_Order,Karshnash_Id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("پیامک ارسال شد")
      }
    )
  }

  Read_Customer_Karshnash(template: TemplateRef<any>){
    this.InProccessing = true


    this.Customer_Service.GetSingle(this.Data_Seleted_Customer.id).subscribe(
      data=>{
        this.InProccessing = false
        this.DataList_Karshnash=data['karshnasMasol']

        if(this.DataList_Karshnash.length==0)
        {
          this.canShowSendSMS=false
        }

        this.modalRef_Code = this.modalService.show(template);
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Selected_Of_Karshnash(item:KarshnasMasol_Interface)
  {
    item.del=!item.del
  }

  //#endregion

  //#region Bazgasht

  modalRef_Bazgasht:any
  Dsc_Bazgasht:string=''
  Selected_Bazgasht_LetterRequestCustomer_Device_Interface:LetterRequestCustomer_Device_Interface=Empty_LetterRequestCustomer_Device_Interface()
  OpenBazgasht(template: TemplateRef<any>, item: LetterRequestCustomer_Device_Interface) {
    this.modalRef_Bazgasht = this.modalService.show(template);
    this.Selected_Bazgasht_LetterRequestCustomer_Device_Interface=item
    this.Dsc_Bazgasht=''
  }

  DeleteBazgashtDevice(sendSms:number)
  {
    if(!this.Dsc_Bazgasht)
    {
      this.Alertify_Service.ErrorMessage("توضیحات را وارد نمائید")
    }
    else{
      this.LetterRequestCustomer_Service.DeleteBazgashtDevice(this.Selected_Bazgasht_LetterRequestCustomer_Device_Interface.id,this.Dsc_Bazgasht).subscribe(
        data=>{

          this.Alertify_Service.SuccessMessage("بازگشت دستگاه ثبت شد")
          this.Selected_Bazgasht_LetterRequestCustomer_Device_Interface.dsc_bazgast=data['outer']
          this.modalRef_Bazgasht.hide()

          if(sendSms==1)
          {
            this.SendSMS_Order=18
            this.SendSMS()
          }
        }
      )
    }
  }

  //#endregion


}
